<template>
    <div class="simulativeTset-view-shell">
        <div :class="{'w-view-shell': show}">
            <!-- 面包屑  -->
            <el-breadcrumb separator-class="el-icon-arrow-right" v-if="show">
                <el-breadcrumb-item :to="'/'">首页</el-breadcrumb-item>
                <el-breadcrumb-item>开始学习</el-breadcrumb-item>
                <el-breadcrumb-item>{{error_type?'错题集':"模拟练习"}}</el-breadcrumb-item>
            </el-breadcrumb>

            <!-- 侧边栏 -->
            <div class="simulativeTset-content-shell">
                <div class="simulativeTset-sider">
                    <div class="sider-box handler" v-for="(item,index) in cate_list" :key="index"
                         :class="{'sider-box-active': cate_code == item.cate_id }"
                         @click.stop="cut_sider(item,index)">
                        {{item.cate_name}}
                    </div>
                </div>
                <div class="simulativeTset-content">
                    <div class="list-shell">
                        <div class="list-box handler" @click="go_test(item2,index2)" v-for="(item2,index2) in list"
                             :key="index2">
                            <img src="@/assets/need_pay.png" alt="" class="is-pay" v-if="item2.is_free==0 && !item2.buy_status">
                            <div class="is-pay" v-if="item2.buy_status">已付费</div>
                            <span>{{item2.qst_name}}</span>
                        </div>
                        <div class="no-data" v-show="list.length<1">
                            无该类型题目
                        </div>
                    </div>
                </div>
            </div>

            <div class="page">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[5, 10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
              </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'simulativeTset',
    data () {
      return {
        tabPosition: 'left',
        cate_list: [],
        list: [],
        cate_code: '',
        error_type: false,
        pageSize: 10,
        pageIndex: 1,
        totalPage: 0
      }
    },
    props: {
      show: {
        type: Boolean,
        default: true
      }
    },
    mounted () {
      if (this.$route.query.error_type) {
        this.error_type = true
      }
      if (this.$route.query.cate_id) {
        this.cate_id = this.$route.query.cate_id
        this.cate_code = this.$route.query.cate_code
        this.get_cate_list()
      } else {
        this.get_cate_list()
      }
    },
    methods: {
      // 每页数
      handleSizeChange (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.get_list()
      },
      // 当前页
      handleCurrentChange (val) {
        this.pageIndex = val
        this.get_list()
      },
      cut_sider(item,index){
        this.cate_code = item.cate_id
        this.get_list()
      },
      go_test (item, index) { // 购买 //测试
        if (item.is_free) { // 1免费 0 付费
          if (this.error_type) {
            this.$router.push('/test?error_type=1&qst_id=' + item.qst_id)
          } else {
            this.$router.push('/test?qst_id=' + item.qst_id)
          }
        } else {
          if (this.error_type) {
            this.$router.push('/purchases?error_type=1&qst_id=' + item.qst_id)
          } else {
            if(item.buy_status){
              this.$router.push('/test?qst_id=' + item.qst_id)
            } else{
              this.$router.push('/purchases?qst_id=' + item.qst_id + '&qst_price='+item.qst_price + '&qst_name='+item.qst_name)
            }
          }
        }
      },
      get_cate_list () {
        this.API.post('Home/question_out-get_question_cate', {}).then((res) => {
          this.cate_list = res.data.cate_list
          this.cate_code = this.cate_code ? this.cate_code : res.data.cate_list[0].cate_id
          this.get_list()
        })
      },
      get_list () {
        this.API.post('Home/question_out-get_question_list', {
          cate_id: this.cate_code,
          page: this.pageIndex,
          page_size: this.pageSize
        }).then((res) => {
          this.totalPage = res.data.cnt_data
          this.list = res.data.question_list
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .simulativeTset-view-shell {
        width: 100%;
        min-height: 100vh;
        background-color: #f4f4f4;
        .page {
          width: 100%;
          display: flex;
          justify-content: flex-end;
        }
    }

    .simulativeTset-content-shell {
        display: flex;
        width: 100%;

        .simulativeTset-sider {
            min-width: 284px;
            background: #fff;

            .sider-box {
                display: flex;
                align-items: center;
                padding: 20px;
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                height: 100px;
            }

            .sider-box-active {
                color: #2AA9B5;
                border-left: 4px solid #2AA9B5;
            }
        }

        .simulativeTset-content {
            flex: 1;
            margin-left: 10px;

            .list-shell {
                .list-box {
                    display: flex;
                    align-items: center;
                    height: 92px;
                    background-color: #fff;
                    margin-bottom: 12px;
                    padding: 20px;
                    position: relative;
                    font-size: 24px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #090909;

                    .is-pay {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        width: 49px;
                        height: 30px;
                        background-color: red;
                        color: #fff;
                        font-size: 12px;
                        border-bottom-right-radius: 8px;
                    }
                }
            }
        }
    }

    .no-data {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 20vh;
        width: 50vw;
        color: orange;
        font-size: 24px;
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
        font-weight: 400;
        color: #000;
        cursor: text;
    }

    .el-breadcrumb {
        height: 47px;
        line-height: 47px;
        font-size: 16px;
        margin: 20px 0;
    }

    /deep/ .el-tabs__item.is-active {
        color: #2aa9b5;
        font-size: 26px;
    }

    /deep/ .el-tabs--left .el-tabs__item.is-left {
        text-align: right;
        font-size: 26px;
        margin-top: 34px;

    }

    /deep/ .el-tabs__active-bar {
        background-color: #2aa9b5;
    }

    /deep/ .el-tabs {
        height: 800px;
        position: relative;
    }

    .van-icon-arrow::before {
        content: "\F00A";
        margin-top: 16px;
    }

    .titleClass {
        width: 394px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #090909;
        margin-left: 10px;
        line-height: 54px;
    }

    .pay {
        position: absolute;
        top: 0;
        left: 0;
    }

    .van-cell--clickable {
        cursor: pointer;
        margin-left: 20px;
    }
</style>
